
import { QueryListView } from "./QueryListView";

export class BulkUpdateListView extends QueryListView{

    constructor(items: any) {
        super(items);
    }

    getListItem(): any[] {
        return this.model;
    }
}